import { AccountDTO, GrantDTO } from '../../Profile/Accounts/api/useAccountsQuery';

export enum DispositionStrategyDTO {
  BasedOnCashflowNeed,
  AsSoonAsPossible,
  AsSoonAsPossibleIsoQualifying,
  AfterXYears,
  SpecificDate,
  AtPrincipalRetirement,
  AtSpouseRetirement,
  Never,
}

export enum ExerciseStrategyDTO {
  AlignedToSale,
  AsSoonAsPossible,
  AfterXYears,
  SpecificDate,
  AtPrincipalRetirement,
  AtSpouseRetirement,
  Never,
}

export interface GrantToUpsert {
  grant: Partial<GrantDTO>;
  account: Partial<AccountDTO>;
  isAddingNewGrant?: boolean;
}

export interface GrantToDelete {
  grant: GrantDTO;
  account: AccountDTO;
}

export enum OwnerTypeDTO {
  Principal = 0,
  Spouse = 1,
  Joint = 2,
  Trust = 3,
  Business = 4,
  Child = 5,
  Grandchild = 6,
  OtherDependent = 7,
  OtherBeneficiary = 8,
  OtherIndividual = 9,
}

export interface OwnerModelDTO {
  Id: string | null;
  Name: string;
  OwnerType: OwnerTypeDTO;
  Percentage: number;
}
